import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {compose} from 'redux';
import {getWindow} from 'ssr-window';
import {v4 as uuidV4} from 'uuid';
import QuickFilters from 'filters/QuickFilters';
import {toggleInfoPanelView} from '../search-actions';
import WithSearchControls from '../controls/WithSearchControls';
import SearchTermToggle from '../controls/SearchTermToggle';
import SearchInput from '../controls/SearchInput';
import SearchDateTimePickers from '../controls/SearchDateTimePickers';
import SearchActions from '../controls/SearchActions';
import SpotListHeading from './SpotListHeading';
import SpotListBreadcrumbs from './SpotListBreadcrumbs';

const window = getWindow();

class SpotListSearchControls extends Component {
    static propTypes = {
        isMobile: PropTypes.bool,
        isAdmin: PropTypes.bool.isRequired,
        timezone: PropTypes.string.isRequired,
        isMonthly: PropTypes.bool,
        starts: PropTypes.string,
        ends: PropTypes.string,
        searchString: PropTypes.string,
        searchBounds: PropTypes.shape({
            swLat: PropTypes.number,
            swLng: PropTypes.number,
            neLat: PropTypes.number,
            neLng: PropTypes.number,
        }),
        isSearching: PropTypes.bool,
        isValidStart: PropTypes.bool,
        onInputChange: PropTypes.func.isRequired,
        onDateTimeChange: PropTypes.func,
        onSubmit: PropTypes.func.isRequired,
        onSearchClick: PropTypes.func,
        numSpots: PropTypes.number.isRequired,
        searchType: PropTypes.string.isRequired,
        breadcrumbs: PropTypes.object,
        showNoSpotsFound: PropTypes.bool,
        onToggleInfoPanel: PropTypes.func.isRequired,
        onToggleInfoModal: PropTypes.func,
        onToggleEventList: PropTypes.func,
    };
    state = {
        inputKey: uuidV4(),
        dateTimeKey: uuidV4(),
        showActions: false,
    };

    componentDidMount() {
        if (window.innerWidth < 900) {
            this.props.onToggleInfoPanel(false);
        }
    }

    _onActionsToggle = isShowing => {
        this.setState({
            showActions: isShowing,
        });
    };

    _onShowInfoClick = () => {
        const {isMobile, onToggleInfoPanel, onToggleInfoModal} = this.props;

        if (isMobile) {
            onToggleInfoModal();
        } else {
            onToggleInfoPanel(true);
        }
    };

    _onSuggestSelect = () => {
        this.setState({
            showActions: true,
        });
    };

    _onDateTimeChange = data => {
        this.setState({
            showActions: true,
        });

        this.props.onDateTimeChange(data);
    };

    _onSearchClick = () => {
        this.setState({
            showActions: false,
        });

        this.props.onSearchClick();
    };

    _onCancelClick = evt => {
        this.setState({
            inputKey: uuidV4(),
            dateTimeKey: uuidV4(),
            showActions: false,
        });
    };

    render() {
        const {
            isMobile,
            isAdmin,
            timezone,
            isMonthly,
            searchString,
            starts,
            ends,
            searchBounds,
            isSearching,
            isValidStart,
            onInputChange,
            onSubmit,
            searchType,
            breadcrumbs,
            showNoSpotsFound,
            numSpots,
            onToggleEventList,
        } = this.props;
        const {inputKey, dateTimeKey, showActions} = this.state;

        return (
            <div className="SpotListSearchControls">
                <div className="SpotListSearchControls-info">
                    <SearchTermToggle isSearching={isSearching} />
                    {!isMobile && searchType !== 'city' && (
                        <SpotListBreadcrumbs data={breadcrumbs} />
                    )}
                </div>
                {searchType !== 'address' && (
                    <SpotListHeading
                        showEventsLink={!isMobile}
                        onShowInfoClick={this._onShowInfoClick}
                        onToggleEventList={onToggleEventList}
                    />
                )}
                <div className="SpotListSearchControls-controls">
                    <SearchInput
                        key={inputKey}
                        isMonthly={isMonthly}
                        isSearching={isSearching}
                        searchString={searchString}
                        searchBounds={searchBounds}
                        onSuggestSelect={this._onSuggestSelect}
                        onChange={onInputChange}
                        onSubmit={onSubmit}
                    />
                    <SearchDateTimePickers
                        key={dateTimeKey}
                        isAdmin={isAdmin}
                        timezone={timezone}
                        isMonthly={isMonthly}
                        starts={starts}
                        ends={ends}
                        onChange={this._onDateTimeChange}
                    />
                    {showActions && (
                        <SearchActions
                            addKeyListeners={!isMobile}
                            showCancel
                            searchButtonText="Update Search"
                            isSearching={isSearching}
                            isValidStart={isValidStart}
                            onSearchClick={this._onSearchClick}
                            onCancelClick={this._onCancelClick}
                        />
                    )}
                </div>
                {numSpots > 0 && !showNoSpotsFound && !showActions && (
                    <QuickFilters
                        showReservationTypes={isMonthly}
                        visibleSlugs={['self-park', 'touchless']}
                        allowTouchlessTooltip
                    />
                )}
            </div>
        );
    }
}

const mapStateToProps = ({
    filters: {numActive},
    search: {
        data: {breadcrumbs, searchType, showNoSpotsFound},
    },
}) => {
    return {
        breadcrumbs,
        numActiveFilters: numActive,
        searchType,
        showNoSpotsFound,
    };
};

const mapDispatchToProps = {
    onToggleInfoPanel: toggleInfoPanelView,
};

const enhance = compose(
    WithSearchControls,
    connect(mapStateToProps, mapDispatchToProps)
);

export default enhance(SpotListSearchControls);
